import { lazy } from "react";

const LoadableTeacherPlatform = lazy(
  () => import(/* webpackChunkName: "teacher-dashboard" */ "./teacher/Route")
);

export default LoadableTeacherPlatform;
